export const FirebaseConfig = {
    apiKey: 'AIzaSyCKXu48mtpEU2rNOjvOTjdS6pOpi3qZsvM',
    authDomain: 'stock-rocket.firebaseapp.com',
    databaseURL: 'https://stock-rocket-default-rtdb.firebaseio.com',
    projectId: 'stock-rocket',
    storageBucket: 'stock-rocket.appspot.com',
    messagingSenderId: '708375683400',
    appId: '1:708375683400:web:d1f688bdc798c09535d37d',
};
